export const POLICIES_SET_LOADING = 'POLICIES/SET_LOADING';
export const POLICIES_SET_ERROR = 'POLICIES/SET_ERROR';
export const POLICIES_SET_POLICIES = 'POLICIES/SET_POLICIES';
export const POLICIES_SET_GROUPS = 'POLICIES/SET_GROUPS';
export const POLICIES_SET_PAGINATION = 'POLICIES/SET_PAGINATION';

export const POLICIES_FETCH_POLICIES = 'POLICIES/FETCH_POLICIES';
export const POLICIES_FETCH_GROUPS = 'POLICIES/FETCH_GROUPS';
export const POLICIES_CLEAR_ERROR = 'POLICIES/CLEAR_ERROR';

export const POLICIES_GET_POLICIES = 'POLICIES/GET_POLICIES';
export const POLICIES_GET_PAGINATION = 'POLICIES/GET_PAGINATION';
export const POLICIES_GET_LOADING = 'POLICIES/GET_LOADING';
export const POLICIES_GET_ERROR = 'POLICIES/GET_ERROR';
